import React, {PureComponent} from 'react';
import {Alert, Button, Form, Spinner, FormFeedback, FormGroup, Label, Input, CustomInput} from "reactstrap";
import {Formik} from "formik";
import * as yup from "yup";
import {requiredMessage} from "../../utils/form-validation";
import Dropdown from "../UI/Dropdown";
import {sanitizeForm} from "../../utils/sanitize-form";
import {ICityEditFormRequest, ICity} from "../../models/City";
import {timezoneOptions} from "../../utils/timezones";
import {externalDeliveryServiceOptions} from "../../utils/order";


const schema = yup.object({
    name: yup.string().required(requiredMessage()),
    timezone: yup.number().nullable().required(requiredMessage()),
    status: yup.boolean().required(requiredMessage()),
    deliveryService: yup.string().nullable().required(requiredMessage()),
});

type CityEditType = {
    editCityForm: (id: number, form: ICityEditFormRequest) => void
    changeLoading: boolean
    changeError: string
    cancelHandler?: () => void
    data: ICity
}

class CityEdit extends PureComponent<CityEditType> {
    render() {
        const {editCityForm, data, changeLoading, changeError, cancelHandler} = this.props;

        return (
            <Formik
                validationSchema={schema}
                onSubmit={(values) => {
                    const name = sanitizeForm(values.name);
                    const timezone = sanitizeForm(values.timezone);
                    const status = sanitizeForm(values.status);
                    const deliveryService = sanitizeForm(values.deliveryService);
                    
                    const form = {
                        name,
                        timezone,
                        status,
                        deliveryService,
                    };

                    editCityForm(data.id, form)
                }}
                initialValues={{
                    name: data.name || '',
                    status: data.status || false,
                    timezone: data.timezone || null,
                    deliveryService: data.deliveryService || null,
                }}
            >
                {({
                      handleSubmit,
                      handleChange,
                      values,
                      touched,
                      errors,
                      dirty,
                      setFieldValue
                  }) => (
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <CustomInput
                                type="switch"
                                id="status"
                                label={values.status ? "Включен" : "Выключен"}
                                onChange={handleChange}
                                name={'status'}
                                checked={values.status}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Название <span className={'required'}>*</span></Label>
                            <Input
                                type="text"
                                name="name"
                                value={values.name}
                                onChange={handleChange}
                                invalid={touched.name && !!errors.name}
                            />
                            <FormFeedback>{errors.name}</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label>Таймзона <span className={'required'}>*</span></Label>
                            <Dropdown
                                name={'timezone'}
                                value={values.timezone}
                                options={timezoneOptions}
                                onChange={(value) => setFieldValue('timezone', value)}
                                invalid={touched.timezone && !!errors.timezone}
                            />
                            <FormFeedback>{errors.timezone}</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label>Внешняя доставка <span className={'required'}>*</span></Label>
                            <Dropdown
                                name={'deliveryService'}
                                value={values.deliveryService}
                                options={externalDeliveryServiceOptions}
                                onChange={(value) => setFieldValue('deliveryService', value)}
                                invalid={touched.deliveryService && !!errors.deliveryService}
                            />
                            <FormFeedback>{errors.deliveryService}</FormFeedback>
                        </FormGroup>
                        {changeError &&
                        (<Alert className={'mt-3'} color={'danger'}>
                            {changeError}
                        </Alert>)}
                        <div className="text-right">
                            {cancelHandler &&
                            <Button color="light" className={'mr-3'} onClick={cancelHandler}>Отменить</Button>}
                            <Button type="submit" color={'success'} disabled={changeLoading || !dirty}>
                                {changeLoading &&
                                (<Spinner
                                    size="sm"
                                />)}
                                Сохранить
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        )
    }
}

export default CityEdit;
